import { styled } from '@mui/material/styles';
import { ImageField } from 'shared/react-admin/Fields';

export const OrdersImageFieldStyled = styled(ImageField)({
  '& .RaImageField-image': {
    margin: 0,
    marginRight: '2px',
    maxWidth: 24,
    maxHeight: 24,
    minWidth: 24,
    minHeight: 24,
    objectFit: 'contain',
  },
});
